export default __webpack_public_path__ + "static/media/Hana_Pharmacy_CPD_Certificate.f4154389.png";